import React from "react";
import TestimonialCard1 from "images/boost/boost_testimonial_card-1.webp";
import TestimonialCard2 from "images/boost/boost_testimonial_card-2.webp";
import TestimonialCard3 from "images/boost/boost_testimonial_card-3.webp";
import TestimonialCard4 from "images/boost/boost_testimonial_card-4.webp";

const TestimonialCards = ({ className }) => {
  return (
    <div className="w-full grid place-items-center md:bg-neutral-300">
      <div
        className={className}
        style={{ maxWidth: 1300 }}
      >
        <div className="font-bold text-2xl text-boost-primary-700 hidden md:block">Hear what others have to say</div>
        <div className="flex overflow-x-scroll hide-x-scrollbar shrink-0 w-full">
          <div className="mx-6 md:mx-10 mt-5 pb-10 flex self-start overflow-visible">
            {
              [TestimonialCard1, TestimonialCard2, TestimonialCard3, TestimonialCard4]
                .map((imageSrc, idx) => (
                  <img
                    alt=""
                    src={imageSrc}
                    // eslint-disable-next-line react/no-array-index-key
                    key={`testimonial-${idx}`}
                    style={{ width: "268px", height: "auto" }}
                    className="pr-6 box-content transform hover:scale-110 transition-transform"
                  />
                ))
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCards;